module.exports = __webpack_public_path__ + "img/1510673722.a0f38fd4.jpg";